import { colors } from "./colors";

/** สถานะคำร้องโอนมรดก — ต้องตรงกับค่าที่ backend ส่งมา (DELETED ถูกกรองออกจากทุก endpoint แล้ว) */
export enum INHERITANCE_STATUS {
  WAITING = "WAITING",
  APPROVE = "APPROVE",
  NOT_APPROVE = "NOT_APPROVE",
}

/** ค่าพิเศษของตัวกรอง ไม่ได้ส่งไป backend (ไม่ส่ง status = ทั้งหมด) */
export const INHERITANCE_STATUS_ALL = "ALL";

/**
 * value ที่รับจาก API -> label บนหน้าจอ
 * ห้ามใช้ t('STATUS.WAITING') จาก common.json เพราะที่นั่นแปลว่า "รอการชำระเงิน"
 */
export const INHERITANCE_STATUS_LABEL: Record<string, string> = {
  [INHERITANCE_STATUS.WAITING]: "รอพิจารณา",
  [INHERITANCE_STATUS.APPROVE]: "อนุมัติ",
  [INHERITANCE_STATUS.NOT_APPROVE]: "ไม่อนุมัติ",
  [INHERITANCE_STATUS_ALL]: "ทั้งหมด",
};

/** สีตัวอักษรและจุดนำหน้าใน dropdown (ใช้ palette เดิมจาก constants/colors) */
export const INHERITANCE_STATUS_COLOR: Record<string, string> = {
  [INHERITANCE_STATUS.WAITING]: colors.lightOrange,
  [INHERITANCE_STATUS.APPROVE]: colors.green,
  [INHERITANCE_STATUS.NOT_APPROVE]: colors.red,
  [INHERITANCE_STATUS_ALL]: colors.gray,
};

/** พื้นหลัง chip ในตาราง — โทนอ่อนของสีเดียวกัน ให้ตัวอักษรยังอ่านออก */
export const INHERITANCE_STATUS_BG: Record<string, string> = {
  [INHERITANCE_STATUS.WAITING]: "rgba(240, 183, 96, 0.18)",
  [INHERITANCE_STATUS.APPROVE]: "rgba(28, 185, 154, 0.14)",
  [INHERITANCE_STATUS.NOT_APPROVE]: "rgba(176, 0, 32, 0.10)",
};

/** ลำดับที่ใช้ render dropdown ตัวกรองสถานะ */
export const INHERITANCE_STATUS_OPTIONS: string[] = [
  INHERITANCE_STATUS_ALL,
  INHERITANCE_STATUS.WAITING,
  INHERITANCE_STATUS.APPROVE,
  INHERITANCE_STATUS.NOT_APPROVE,
];

/** ผลการพิจารณาที่เลือกได้ใน modal พิจารณา (ไม่มี WAITING) */
export const INHERITANCE_REVIEW_OPTIONS: string[] = [
  INHERITANCE_STATUS.APPROVE,
  INHERITANCE_STATUS.NOT_APPROVE,
];

/** สถานะที่ยังไม่รู้จัก ให้โชว์ค่าดิบไว้ก่อน ดีกว่าโชว์ "-" แล้วข้อมูลหายไปเฉยๆ */
export const inheritanceStatusLabel = (status?: string) =>
  (status && INHERITANCE_STATUS_LABEL[status]) || status || "-";

export const inheritanceStatusColor = (status?: string) =>
  (status && INHERITANCE_STATUS_COLOR[status]) || colors.gray;

export const inheritanceStatusBg = (status?: string) =>
  (status && INHERITANCE_STATUS_BG[status]) || colors.extraLightGray;

/** สถานะสัญญาเช่าของแผงค้าในตาราง snapshot / ข้อมูลสด */
export const LEASE_STATUS_LABEL: Record<string, string> = {
  ACTIVE: "สัญญาเช่า",
  INACTIVE: "ไม่ใช้งาน",
  CANCEL: "ยกเลิกสัญญา",
  TRANSFER: "โอนสิทธิแล้ว",
};

export const LEASE_STATUS_COLOR: Record<string, string> = {
  ACTIVE: colors.green,
  INACTIVE: colors.gray,
  CANCEL: colors.red,
  TRANSFER: colors.lightOrange,
};

export const leaseStatusLabel = (status?: string) =>
  (status && LEASE_STATUS_LABEL[status]) || status || "-";

export const leaseStatusColor = (status?: string) =>
  (status && LEASE_STATUS_COLOR[status]) || colors.gray;

/** ค่าที่ backend ใช้บอกว่า log แถวนั้นคือตอนยื่นคำร้อง (ไม่มีผลการพิจารณา) */
export const INHERITANCE_LOG_ACTION_LABEL: Record<string, string> = {
  CREATE: "ยื่นคำร้อง",
  REVIEW: "พิจารณาคำร้อง",
  DELETE: "ลบคำร้อง",
};

/** ไฟล์แนบตอนพิจารณา — สูงสุด 10 ไฟล์ ไฟล์ละไม่เกิน 10 MB ตามที่ backend จำกัด */
export const INHERITANCE_REVIEW_MAX_FILES = 10;
export const INHERITANCE_REVIEW_MAX_FILE_SIZE = 10 * 1024 * 1024;
/** react-dropzone 14 ต้องใช้ accept แบบ object และให้ accept เป็นตัวคัดกรองเดียว */
export const INHERITANCE_REVIEW_ACCEPT = {
  "application/pdf": [".pdf"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
};
/** รายละเอียดการพิจารณา backend จำกัดไว้ 5000 ตัวอักษร */
export const INHERITANCE_REVIEW_MAX_NOTE_LENGTH = 5000;

/**
 * ค่าเริ่มต้นของ modal ทำรายการโอนมรดก เมื่อเข้ามาจากหน้าจัดการข้อมูลลูกค้า (หลังรับเอกสารผู้รับมรดก)
 * ส่งผ่าน router state (อยู่ในหน่วยความจำ) — ไม่ลง localStorage/URL เพราะเป็นข้อมูลส่วนบุคคล
 */
export type InheritanceCreatePrefill = {
  /** key ของผู้โอน (OwnerSuggestion.userId) ไม่ใช่ customerId */
  userId_owner: number;
  customerId_owner: number | null;
  owner_fullname: string;
  /** ผู้รับมรดกที่ต้องการเลือกไว้ให้ (HeirOption.id_customer_agent) */
  id_customer_agent?: number;
};

export type InheritanceTransferLocationState = {
  createPrefill?: InheritanceCreatePrefill;
};
